import { render, staticRenderFns } from "./ModalBtn.vue?vue&type=template&id=658a121f&scoped=true&lang=pug&"
import script from "./ModalBtn.vue?vue&type=script&lang=js&"
export * from "./ModalBtn.vue?vue&type=script&lang=js&"
import style0 from "./ModalBtn.vue?vue&type=style&index=0&id=658a121f&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "658a121f",
  null
  
)

export default component.exports